<template>
  <div>
    <Head title="Feedbacks" />
    <h1 class="mb-8 text-3xl font-bold">Feedbacks</h1>
    <div class="mb-6 flex flex-col gap-4">
      <div class="grid grid-cols-1 md:grid-cols-5 gap-4">
        <FloatLabel>
          <Select
            id="course_filter"
            v-model="localFilters.course_id"
            :options="courseOptions"
            option-label="label"
            option-value="value"
            class="w-full"
            show-clear
            @change="applyFilters"
            @clear="applyFilters"
          />
          <label for="course_filter">Curs</label>
        </FloatLabel>
        <FloatLabel>
          <Select
            id="active_filter"
            v-model="localFilters.active"
            :options="activeOptions"
            option-label="label"
            option-value="value"
            class="w-full"
            show-clear
            @change="applyFilters"
            @clear="applyFilters"
          />
          <label for="active_filter">Status curs</label>
        </FloatLabel>
        <FloatLabel>
          <Select
            id="status_filter"
            v-model="localFilters.status"
            :options="statusOptions"
            option-label="label"
            option-value="value"
            class="w-full"
            show-clear
            @change="applyFilters"
            @clear="applyFilters"
          />
          <label for="status_filter">Status Feedback</label>
        </FloatLabel>
        <FloatLabel>
          <Select
            id="files_filter"
            v-model="localFilters.files"
            :options="filesOptions"
            option-label="label"
            option-value="value"
            class="w-full"
            show-clear
            @change="applyFilters"
            @clear="applyFilters"
          />
          <label for="files_filter">Status Fisiere</label>
        </FloatLabel>
        <FloatLabel>
          <Select
            id="user_filter"
            v-model="localFilters.user_id"
            :options="userOptions"
            option-label="label"
            option-value="value"
            class="w-full"
            show-clear
            @change="applyFilters"
            @clear="applyFilters"
          />
          <label for="user_filter">User</label>
        </FloatLabel>
      </div>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">User</th>
            <th class="px-6 pt-6 pb-4">Course</th>
            <th class="px-6 pt-6 pb-4">Subject</th>
            <th class="px-6 pt-6 pb-4">New Files</th>
            <th class="px-6 pt-6 pb-4">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="feedback in feedbacks"
            :key="feedback.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
          >
            <td class="border-t">
              <Link
                :href="$routes.feedback(feedback.id)"
                class="flex items-center px-6 py-4"
                tabindex="-1"
              >
                {{ feedback.user_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                :href="$routes.feedback(feedback.id)"
                class="flex items-center px-6 py-4"
                tabindex="-1"
              >
                {{ feedback.course_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                :href="$routes.feedback(feedback.id)"
                class="flex items-center px-6 py-4"
                tabindex="-1"
              >
                {{ feedback.subject_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                :href="$routes.feedback(feedback.id)"
                class="flex items-center px-6 py-4"
                tabindex="-1"
              >
                {{
                  feedback.uploader_files_count > 0
                    ? `+${feedback.uploader_files_count}`
                    : feedback.uploader_files_count
                }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                :href="$routes.feedback(feedback.id)"
                class="flex items-center px-6 py-4"
                tabindex="-1"
              >
                <span
                  class="px-2 py-1 text-xs font-semibold rounded"
                  :class="
                    feedback.completed
                      ? 'bg-green-100 text-green-800'
                      : feedback.total_files === 0
                        ? 'bg-gray-100 text-gray-600'
                        : 'bg-yellow-100 text-yellow-800'
                  "
                >
                  {{
                    feedback.completed
                      ? 'Completed'
                      : feedback.total_files === 0
                        ? 'Inactive'
                        : 'Pending'
                  }}
                </span>
              </Link>
            </td>
          </tr>
          <tr v-if="feedbacks.length === 0">
            <td class="px-6 py-4 border-t text-center" colspan="5">
              No feedbacks found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import Select from 'primevue/select';
import FloatLabel from 'primevue/floatlabel';

export default {
  components: {
    Head,
    Link,
    Select,
    FloatLabel,
  },
  layout: Layout,
  props: {
    feedbacks: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
    courses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localFilters: {
        status: this.filters.status ?? null,
        files: this.filters.files ?? null,
        active: this.filters.active ?? 'active',
        course_id: this.filters.course_id ?? null,
        user_id: this.filters.user_id ?? null,
      },
      statusOptions: [
        { label: 'Nefinalizat', value: 'pending' },
        { label: 'Finalizat', value: 'completed' },
      ],
      filesOptions: [
        { label: 'Cu fisiere', value: 'with_files' },
        { label: 'Fara fisiere', value: 'without_files' },
      ],
      activeOptions: [
        { label: 'Activ', value: 'active' },
        { label: 'Inactiv', value: 'inactive' },
      ],
      courseOptions: [
        ...this.courses.map((c) => ({ label: c.name, value: c.id })),
      ],
    };
  },
  computed: {
    userOptions() {
      return [...this.users.map((u) => ({ label: u.name, value: u.id }))];
    },
  },
  methods: {
    applyFilters() {
      const params = {};
      Object.entries(this.localFilters).forEach(([key, val]) => {
        if (val !== null && val !== undefined) params[key] = val;
      });
      this.$inertia.get(this.$routes.feedbacks(), params, {
        preserveState: true,
        replace: true,
      });
    },
  },
};
</script>
